/**
 * ProgressStepper — Step-by-step progress display with progress bar.
 */

export default function ProgressStepper({ steps, currentIndex }) {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-xl p-5 mb-6">
      <div className="space-y-2.5">
        {steps.map((step, i) => {
          const isDone = i < currentIndex;
          const isCurrent = i === currentIndex;
          const isPending = i > currentIndex;
          return (
            <div key={i} className="flex items-center gap-3">
              {isDone && (
                <span className="w-5 h-5 rounded-full bg-green-100 text-green-700 flex items-center justify-center text-xs flex-shrink-0">&#10003;</span>
              )}
              {isCurrent && (
                <div className="w-5 h-5 animate-spin rounded-full border-2 border-gray-200 border-t-indigo-600 flex-shrink-0" />
              )}
              {isPending && (
                <span className="w-5 h-5 rounded-full bg-gray-200 flex-shrink-0" />
              )}
              <span className={`text-sm ${isDone ? 'text-green-700 line-through' : isCurrent ? 'text-indigo-700 font-medium' : 'text-gray-400'}`}>
                {step}
              </span>
            </div>
          );
        })}
      </div>
      {currentIndex < steps.length && (
        <div className="mt-4">
          <div className="w-full bg-gray-200 rounded-full h-1.5">
            <div className="bg-indigo-500 h-1.5 rounded-full transition-all duration-700" style={{ width: `${(currentIndex / steps.length) * 100}%` }} />
          </div>
          <div className="text-xs text-gray-400 mt-1.5 text-right">{currentIndex}/{steps.length} complete</div>
        </div>
      )}
    </div>
  );
}
